import { createSvgIcon } from "@mui/material/utils";
import React from "react";

const TrackMapIcon = createSvgIcon(
  <path
    d="M109 390 22 244C5 215 37 201 68 212c22 8 38 24 59 24 20 0 31-12 37-32l17-51c3-10 9-17 18-22L397 14c18-11 37-5 49 15l39 70c15 27 3 52-26 55-11 1-23 0-34-3l-108-28c-8-2-15-1-22 4l-45 28c-20 13-25 36-13 56l21 36c7 12 3 27-9 34l-119 72c-15 9-19 27-10 41l8 13"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={34}
    transform="translate(0 2) scale(0.048)"
  />,
  "TrackMap"
);

export default TrackMapIcon;
